const Index = () => {
  return (
    <div>
      <h1>Check Out</h1>
    </div>
  );
}

export default Index;